import script from "./ExcellentVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./ExcellentVideo.vue?vue&type=script&setup=true&lang=js"

import "./ExcellentVideo.vue?vue&type=style&index=0&id=f74595fa&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户海南大学-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f74595fa"]])

export default __exports__